<template>
<v-app-bar
      app
      color="grey lighten-4"
    >
          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>




  </v-app-bar>
</template>


<script>

  import axios from 'axios';

  export default {
    data: () => ({
      passwordAlert: false,
      message: '',
      alert: false,
      pId: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      items: [],
      name: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {

        console.log("Here in App Logic")
      
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
             window.location.href = 'https://play.google.com/store/apps/details?id=com.onlinerene.cpmobile&hl=en_US&gl=US';

           
     }
         if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1){
             window.location.href = 'https://apps.apple.com/us/app/conciergepad-mobile/id1512236778';
             
     }

  },

    methods: {


      getUserId:function(inId) {

      axios.get('https://api.conciergepadedu.com/api/Users/GetUserId/' +  inId).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;

      } else {

        console.log(response.data);

        //successful
        this.validCode = true;
        this.invalidCode = false;

        this.items = response.data;

        this.username = this.items.username;


        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },
    updateUser() {

      if (this.password.length == 0 || this.reTypePassword == 0) {

        this.passwordAlert = true;
        this.message = "Password can't be blank";

      }
      else if (this.password != this.reTypePassword) {

        this.passwordAlert = true;
        this.message = "Passwords have to match";
      }
       else if (this.password.length < 7) {

        this.passwordAlert = true;
        this.message = "Passwords have to be at least 6 digits";
      }

       else if (this.invalidCode == true) {

         console.log("Invalid Email");

      }

      else {

        this.passwordAlert = false;
        this.message = "";

      axios.put('https://api.conciergepadedu.com/api/Users/PutUser/' + String(this.pId),{ 
         ID: String(this.pId),
         USERNAME: this.items.logiN_UUID,
         PASSWORD:  this.password,
         COMPANY_NAME: this.items.companY_NAME,
         UUID: this.items.uuid,
         DATE_CREATED: this.items.datE_CREATED,
         MOBILE_PHONE:  this.items.mobilE_PHONE,
         FIRST_NAME: this.items.firsT_NAME,
         LAST_NAME: this.items.lasT_NAME,
         EMAIL: this.username,
         DOB: this.items.dob,
         HANGER_ID: this.items.hangeR_ID
      }).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

      } else {


          this.alert = true;

          this.password = '';
          this.reTypePassword = '';
          this.validCode = false;
          this.invalidCode = false;


        } 

  

        }).catch(error => {

            console.log(error.response)




        });

      }

    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>